import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';
import { map, catchError } from 'rxjs/operators';
import { Parrainage } from '@app/models/parrainage';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ParrainageService {
    private subject = new Subject<any>();

    constructor(private httpClient: HttpClient) { }

    getParrainages() {
        return this.httpClient.get<any>(`${environment.apiEndPoint}parrainages/read`)
        .pipe(
            map(res => res ? res.document.records as Parrainage[] : []),
            catchError(this.handleError)
        );
    }

    // Admin : recuperation de tous les parrainages
    getParrainagesToManage() {
        return this.httpClient
        .get<any>(`${environment.apiEndPoint}parrainages/read_manage`)
            .pipe(
                map(res => res ? res.document.records as Parrainage[] : []),
                catchError(this.handleError)
            );
    }

    getTotalParrainagesById(id) {
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}parrainages/read_total`, JSON.stringify({ id: `${id}` }))
            .pipe(
                map(res => res.document),
                catchError(this.handleError)
            );
    }

    getParrainagesById(id) {
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}parrainages/read`, JSON.stringify({ id: `${id}` }))
            .pipe(
                map(res => res ? res.document.records as Parrainage[] : []),
                catchError(this.handleError)
            );
    }
    
    createParrainage(object: Parrainage) {
        return this.httpClient
            .post(`${environment.apiEndPoint}parrainage/create`, object)
            .pipe(
                map(res => res),
                catchError(this.handleError)
            );
    }

    ChangeAllParrainagesStatus(proposition_id){
        return this.httpClient
            .post(`${environment.apiEndPoint}parrainages/update`, proposition_id)
            .pipe(
                map(res => res),
                catchError(this.handleError)
            );
    }

    clearParrainages() {
        this.subject.next(null);
    }

    getParrainage(): Observable<any> {
        return this.subject.asObservable();
    }

    private handleError(error: any): Promise<any> {
        let retour = error?.error?.message || error?.message || error;
        if(error?.error?.data) retour += '<br />'+error?.error?.data;
        return Promise.reject(retour);
    }
}